import type { ReactNode, Ref } from 'react'

export interface ListProps {
  scrollZoneRef: Ref<HTMLDivElement>
  children?: ReactNode
}

export function List({ scrollZoneRef, children }: ListProps) {
  return (
    <div>
      <div ref={scrollZoneRef} />
      {children}
    </div>
  )
}
